import {
  FormWrapper,
  FormGroup,
  Form
} from "../../../../components/CustomForm/FormStyles";
import { Section } from "../../../../components/CustomLayout/CustomLayoutStyles";
import CustomInput from "../../../../components/CustomForm/CustomInput";
import CustomSelect from "../../../../components/CustomForm/CustomSelect";
import Colors from "../../../../themes/Colors";
import useEmpresa from "../../../../hooks/useEmpresa";
import { DATE_FORMATS } from "../../../../utils/Constant";

import moment from "moment";

const PrecertificacionDatosSolicitud = (props) => {
  const { onFieldChange, datosCertificacion, tiposSolicitudes } = props;
  const empresa = useEmpresa();
  return (
    <>
      <Section>
        <FormWrapper borderColor={Colors.transparent}>
          <Form>
            <FormGroup>
              <CustomInput
                disabled={true}
                font={empresa?.LETRA_PRINCIPAL}
                type={"text"}
                label={"Fecha"}
                isLabelWithContainer={true}
                value={moment(datosCertificacion.fecha).format(
                  DATE_FORMATS.slash
                )}
                onChange={onFieldChange("fecha")}
              />
            </FormGroup>

            <FormGroup>
              <CustomSelect
                font={empresa?.LETRA_PRINCIPAL}
                type={"text"}
                label={"Tipo Solicitud"}
                isLabelWithContainer={true}
                showDefaultOption={true}
                options={[
                  ...tiposSolicitudes.map((x) => ({
                    label: x.nombre,
                    value: x.id
                  }))
                ]}
                value={datosCertificacion?.tipoSolicitud}
                onChange={onFieldChange("tipoSolicitud")}
              />
            </FormGroup>

            <FormGroup>
              <CustomInput
                font={empresa?.LETRA_PRINCIPAL}
                type={"text"}
                label={"Teléfono PSS"}
                isLabelWithContainer={true}
                value={datosCertificacion?.telefono}
                onChange={onFieldChange("telefono")}
                maxLength={10}
                required={true}
                showRequired={true}
              />
            </FormGroup>

            <FormGroup>
              <CustomInput
                font={empresa?.LETRA_PRINCIPAL}
                type={"text"}
                label={"Correo Electrónico PSS"}
                isLabelWithContainer={true}
                value={datosCertificacion?.correo}
                onChange={onFieldChange("correo")}
                required={true}
                showRequired={true}
              />
            </FormGroup>

            <FormGroup>
              <CustomInput
                font={empresa?.LETRA_PRINCIPAL}
                type={"text"}
                label={"Médico Prescriptor"}
                isLabelWithContainer={true}
                value={datosCertificacion?.medicoPrescriptor}
                onChange={onFieldChange("medicoPrescriptor")}
                required={true}
                showRequired={true}
              />
            </FormGroup>

            <FormGroup>
              <CustomInput
                font={empresa?.LETRA_PRINCIPAL}
                type={"text"}
                label={"Diagnóstico"}
                isLabelWithContainer={true}
                value={datosCertificacion?.diagnostico}
                onChange={onFieldChange("diagnostico")}
                required={true}
                showRequired={true}
              />
            </FormGroup>

            <FormGroup width={"98%"}>
              <CustomInput
                height={"60px"}
                font={empresa?.LETRA_PRINCIPAL}
                placeholder={"Comentarios"}
                type={"text"}
                value={datosCertificacion?.comentarios}
                onChange={onFieldChange("comentarios")}
              />
            </FormGroup>
          </Form>
        </FormWrapper>
      </Section>
    </>
  );
};

export default PrecertificacionDatosSolicitud;
